import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { marketingAllowed, onConsentChanged } from '../utils/consent';
import { loadPixel, unloadPixel, trackPageView, isLoaded } from '../utils/metaPixel';

/**
 * Mounts at the root of the app. Responsibilities:
 *   1. On boot, load the Meta Pixel iff the user has already opted in.
 *   2. Listen for consent changes (banner save) and load/unload accordingly.
 *   3. Fire a PageView on every React Router route change while the pixel
 *      is active (SPA navigation otherwise wouldn't trigger fbevents).
 *
 * Renders nothing.
 */
export default function MetaPixelManager() {
  const location = useLocation();

  // Boot + react to consent changes.
  useEffect(() => {
    if (marketingAllowed()) loadPixel();
    const off = onConsentChanged(() => {
      if (marketingAllowed()) loadPixel();
      else unloadPixel();
    });
    return off;
  }, []);

  // Track SPA route changes.
  useEffect(() => {
    if (!isLoaded()) return;
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
